<div class="content" (tap)="onTap($event)" (pan)="onPan($event)" (pinch)="onPinch($event)">
  <h1>User actions</h1>
  <h4>List of Control Actions</h4>
  <div class="content__actions">
    <div class="content__action" *ngFor="let controlAction of controlActions.values()">
      <div class="content__action-name" [class.is-active]="controlAction?.isActive">
        {{ controlAction?.actionType }}
      </div>
      <div class="content__action-description">{{ getActionDescription(controlAction?.actionType) }}</div>
    </div>
  </div>
</div>
